export default {
  name: "LsBubbles",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  g: [
    {
      fill: "#e7b923",
      "fill-rule": "evenodd",
      d:
        "M29.18 9.7C25.71 4.36 15.77.5 11.46 4.94c-.48.49-.92 1.01-1.31 1.56 1.3.21 2.4 1.03 2.99 2.2.7 1.41.82 5.26-.45 7.34.41.44.74.95.98 1.5.55 1.13.9 2.34 1 3.58.85.47 1.74.84 2.66 1.11 1.65.36 3.34.42 5.01.18a9.4 9.4 0 0 0 5.34-2.43c2.63-2.44 3.88-6.63 1.5-10.3",
      "clip-rule": "evenodd",
    },
    {
      fill: "#5fb8de",
      "fill-rule": "evenodd",
      d:
        "M6.27 16.14a6.9 6.9 0 0 1 2.89-1.23 8.31 8.31 0 0 1 1.01-8.4c-1.46-.26-2.96-.2-4.39.18-2.85.65-3.63 2.03-3.56 4.9a7.05 7.05 0 0 0 2.89 5.63c.34-.4.73-.77 1.16-1.08",
      "clip-rule": "evenodd",
    },
    {
      fill: "#638339",
      "fill-rule": "evenodd",
      d:
        "M9.16 14.91c.89-.17 1.81-.04 2.62.38.35.2.67.45.94.75 1.26-2.08 1.15-5.92.44-7.33-.58-1.17-1.7-2-2.99-2.2a8.3 8.3 0 0 0-1.01 8.4",
      "clip-rule": "evenodd",
    },
    {
      fill: "#e90c8b",
      "fill-rule": "evenodd",
      d:
        "M10.71 17.59c-.75.29-1.54.45-2.35.47a4.94 4.94 0 0 1-3.25-.84c-1.4 1.6-2 3.75-1.63 5.84.91-.05 1.87.15 2.28 1.03.25.68.31 1.4.19 2.12 2.63 1.49 5.2.84 7.88-2.43.63-.74.93-1.7.85-2.66a8.63 8.63 0 0 1-2.24-1.58c-.63-.6-1.2-1.26-1.74-1.96",
      "clip-rule": "evenodd",
    },
    {
      fill: "#c12429",
      "fill-rule": "evenodd",
      d:
        "M12.7 16.04c-.24.42-.57.78-.97 1.04-.33.19-.67.36-1.01.5.52.7 1.1 1.36 1.73 1.97a8.61 8.61 0 0 0 2.24 1.58 10.34 10.34 0 0 0-1-3.58 5.53 5.53 0 0 0-.98-1.5",
      "clip-rule": "evenodd",
    },
    {
      fill: "#6d2977",
      "fill-rule": "evenodd",
      d:
        "M8.36 18.04c.8-.02 1.6-.18 2.35-.47a12.4 12.4 0 0 1-1.55-2.66 6.91 6.91 0 0 0-4.05 2.31c.95.64 2.1.93 3.25.82",
      "clip-rule": "evenodd",
    },
    {
      fill: "#739143",
      "fill-rule": "evenodd",
      d:
        "M9.93 14.85c-.25 0-.5.02-.74.05h-.03c.4.96.94 1.86 1.57 2.69.35-.15.7-.32 1.02-.51.4-.27.73-.62.97-1.04a3.7 3.7 0 0 0-.94-.75l-.06-.03a3.82 3.82 0 0 0-1.73-.4",
      "clip-rule": "evenodd",
    },
    {
      fill: "#69252d",
      "fill-rule": "evenodd",
      d:
        "M11.76 15.3a4.05 4.05 0 0 0-2.62-.39c.4.96.93 1.86 1.57 2.68.35-.15.7-.32 1.02-.5.4-.27.73-.62.97-1.04a3.7 3.7 0 0 0-.94-.75",
      "clip-rule": "evenodd",
    },
    {
      fill: "#ef8128",
      "fill-rule": "evenodd",
      d:
        "M5.98 26.23c0 .6-.3 1.18-.81 1.52-.45.27-.96.42-1.48.43C2.16 28.33 1 26.84 1 25.35c-.03-1.26.31-1.86 1.56-2.14.3-.08.61-.13.92-.15h.03a4.7 4.7 0 0 0 2.16 2.98l.3.19z",
      "clip-rule": "evenodd",
    },
    {
      fill: "#e4232b",
      "fill-rule": "evenodd",
      d:
        "M6 25.5c0 .24-.01.48-.05.71l-.3-.18a4.7 4.7 0 0 1-2.17-2.98h.27l.01.02c.81-.09 1.6.31 2 1.01.18.45.26.93.25 1.42z",
      "clip-rule": "evenodd",
    },
    {
      fill: "#cf1f41",
      "fill-rule": "evenodd",
      d:
        "m5.94 26.22-.31-.18a4.7 4.7 0 0 1-2.16-2.98c.93-.06 1.9.14 2.32 1.03h-.02c.25.68.3 1.42.17 2.13z",
      "clip-rule": "evenodd",
    },
  ],
}
